export default {
    routerName: 'ロール編集',
    role: {
        name: 'ロール名',
        code: 'コード',
        authority: '権限',
        status: '状態',
        open: '有効',
        close: '無効',
        sortOrder: 'ソート',
        remark: '備考',
    },
    menu: {
        menuDistribute: '配分',
    },
};
